import React, { useRef, useState } from "react";
import "../../assets/css/SearchWithDate.css";
import search from "../../assets/images/search.svg";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";


const SearchWithDate = ({ ...props }) => {
    const [value, setValue] = useState({ search: null, checkIn: null, checkOut: null, room: null, guest: null  });

  return (
    <div className="main accomodation-search">
      <div className="search-input-wrapper">
        <span className="search-icon">
          <img src={search} alt="" />
        </span>
        <input
          type="text"
          className="search-input"
          onChange={e => setValue({ ...value, search: e.target.value })}
          { ...props }
        />


        <div className="date-input-container" style={{width:"100px",borderLeft:"1px solid #6761614f"}}>
          <label forHtml='' className={`date-label ${value.checkIn ? "filled" : ""}`}>
            Check In
          </label>
          
          <DatePicker
            className="date-input"
            selected={value.checkIn}
            onChange={(e) => setValue({ ...value, checkIn: e })}
            placeholderText="Check In"
          />
        </div>
        <div className="date-input-container"  style={{width:"100px"}}>
          <label forHtml='' className={`date-label ${value.checkOut ? "filled" : ""}`}>
            Check Out
          </label>
          <DatePicker
            className="date-input"
            selected={value.checkOut}
            onChange={(e) => setValue({ ...value, checkOut: e })}
            placeholderText="Check Out"
          />
        </div>

        <div className="date-input-container"   style={{width:"75px"}}>
          <label forHtml='' className={`date-label ${value.guest ? "filled" : ""}`}>
            Rooms
          </label>
          <input
            type="number"
            className="date-input"
            value={value.room}
            onChange={(e) => setValue({ ...value, room: e.target.value })}
            placeholder="Rooms"
          />
        </div>
        
        <div className="date-input-container"  style={{width:"100px", borderRight:"none"}}>
          <label forHtml='' className={`date-label ${value.room ? "filled" : ""}`}>
            Guest
          </label>
          <input
            type="number"
            className="date-input"
            value={value.guest}
            onChange={(e) => setValue({ ...value, guest: e.target.value })}
            placeholder="No of Guest"
          />
        </div>
        <Link to={`/search-result?search=${ value.search }&checkIn=${ value.checkIn }&checkOut=${ value.checkOut }&room=${ value.room }&guest=${ value.guest }`} className="search-button">
          Search
        </Link>
      </div>
    </div>
  );
};
export default SearchWithDate;
